import ApiService from '@/services/api.service'
import store from '@/globalvar.js'

const ProviderService = {

    getLookUp(UserId){
        return ApiService.get(`/Providers/LookUp?UserId=${UserId}&IncludeTraining=true`);
    },

    getVisibleSettings(){
        return ApiService.get(`/Providers/VisibleSettings`);
    },

    async ensureVisibleSettings(){
        if(!store.state.providerVisibleSettingsLoaded){
            const response = await ProviderService.getVisibleSettings();
            if(response.status == '200' && response.data){
                store.commit('setProviderVisibleSettings', response.data);
            }
        }
        return store.state;
    },

    getFullProvidersNoTraining(){
        return ApiService.get(`/providers?IncludeTraining=true`);
    },

    SelectProvider(code){
        return ApiService.post(`/auth/provider/`,code)
    },

    SelectUserRestrictions(data){
        return ApiService.post(`/auth/restrictions/`, data)
    }

}

export default ProviderService;
